import config from 'config';
import BaseStore from 'stores/BaseStore';
import HttpClient from 'utils/httpclient';

class SubIdStore extends BaseStore {
  constructor() {
    super('subids', 'subid');
  }

  async saveBulk(data, params) {
    const { data: { ok } } = await HttpClient.post(`${config.api}/${this.collectionName}/bulk`, data, { params });
    return ok
  }
}

export default new SubIdStore();
